import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Search, Shield, FileText, CheckCircle } from 'lucide-react';
import { Check } from 'lucide-react';

export default function TrademarkSearch({ onOpenPopup }) {
  const benefits = [
    { icon: <Search className="h-6 w-6" />, title: 'Thorough Research', description: 'Comprehensive search of federal and state databases' },
    { icon: <Shield className="h-6 w-6" />, title: 'Risk Assessment', description: 'Identify potential conflicts before filing' },
    { icon: <FileText className="h-6 w-6" />, title: 'Detailed Report', description: 'Receive a comprehensive search report with findings' },
    { icon: <CheckCircle className="h-6 w-6" />, title: 'Expert Analysis', description: 'Professional evaluation of trademark availability' },
  ];

  const details = [
    { icon: <Check className="h-5 w-5 text-red-700" />, title: 'Federal Database Search', description: 'We search the USPTO database for identical and similar trademarks in your class of goods/services.' },
    { icon: <Check className="h-5 w-5 text-red-700" />, title: 'State Trademark Search', description: 'Comprehensive search of state trademark registries to identify potential conflicts.' },
    { icon: <Check className="h-5 w-5 text-red-700" />, title: 'Common Law Search', description: 'Research of unregistered trademarks and business names that could pose conflicts.' },
    { icon: <Check className="h-5 w-5 text-red-700" />, title: 'Detailed Analysis Report', description: 'Receive a professional report with our findings and recommendations for your trademark.' },
  ];

  const faqs = [
    { question: 'Why do I need a trademark search?', answer: 'A thorough search helps avoid costly rejections and potential infringement issues by identifying existing marks that could conflict with yours.' },
    { question: 'How comprehensive is the search?', answer: 'We search federal, state, and common law sources to provide the most thorough analysis possible.' },
    { question: 'What happens if conflicts are found?', answer: 'We provide guidance on whether to proceed, modify your mark, or choose an alternative based on the conflicts discovered.' },
  ];

  return (
    <ServiceTemplate
      title="Trademark Comprehensive Search"
      subtitle="Risk-Free Registration"
      description="Ensure your trademark is available with our comprehensive search services. We conduct thorough research to identify potential conflicts before you invest in registration."
      heroImage="https://images.unsplash.com/photo-1769092992534-f2d0210162b9"
      infoImage="https://images.pexels.com/photos/7821476/pexels-photo-7821476.jpeg"
      benefits={benefits}
      details={details}
      faqs={faqs}
      onOpenPopup={onOpenPopup}
      testId="trademark-search-page"
      metaTitle="Trademark Search Services - Comprehensive Database Research | Trademark Venus"
      metaDescription="Professional trademark search to avoid registration conflicts. Search federal, state, and common law databases. Detailed analysis report with recommendations. Ensure your trademark is available before filing."
    />
  );
}
